import { X } from "lucide-react";

export default function EliminarEventoModal({
    isOpen,
    onClose,
    loadingDeleteEvento,
    onSubmit
}) {








    const handleClose = () => {
        onClose();
    };



    if (!isOpen) return null;

    return (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
            <div className="fixed inset-0 flex items-center justify-center z-50 p-4 pointer-events-none">
                <div className="bg-white rounded-lg shadow-xl w-full max-w-md pointer-events-auto">
                    {/* Header del Modal */}
                    <div className="flex items-center justify-between p-6 border-b border-gray-200">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900">
                                Eliminar Evento
                            </h2>
                            <p className="text-sm text-gray-500 mt-1">
                                Estas a punto de eliminar este evento. Esta acción es irreversible.
                            </p>
                        </div>


                        <button
                            onClick={handleClose}
                            className="text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>





                    <div className="flex justify-end gap-4 p-6">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors cursor-pointer"
                        >
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                            disabled={loadingDeleteEvento}
                            onClick={onSubmit}
                        >
                            {loadingDeleteEvento ? 'Procesando...' : 'Eliminar Evento'}
                        </button>
                    </div>


                </div>
            </div>
        </div>
    );
}